/* NORDBLANC: Dostupnost na prodejnách – načtení stavů z Helios proxy a filtry draweru.
   Otevírání/zavírání řeší modal-opener/modal-dialog z global.js; tady jen data a UI stavy. */
(function () {
  'use strict';
  if (window.nbBranchAvailabilityInit) return;
  window.nbBranchAvailabilityInit = true;

  var fold = function (s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  };

  function currentSize(modal) {
    var picker = document.getElementById('variant-picker-' + modal.dataset.sectionId);
    if (!picker) return null;
    var fs = picker.querySelector('fieldset[data-option-position="' + modal.dataset.optionPosition + '"]');
    if (!fs) return null;
    var checked = fs.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    var hidden = fs.querySelector('input[type="hidden"]');
    return hidden ? hidden.value : null;
  }

  function highlightCurrent(modal) {
    var size = currentSize(modal);
    modal.querySelectorAll('.nb-chip').forEach(function (chip) {
      chip.classList.toggle('nb-chip--current', size !== null && chip.dataset.size === size);
    });
  }

  function applyFilters(modal) {
    var q = fold(modal.querySelector('[data-nb-search]').value.trim());
    var only = modal.querySelector('[data-nb-only-stock]').checked;
    modal.classList.toggle('nb--only-stock', only);
    var visible = 0;
    modal.querySelectorAll('.nb-store').forEach(function (li) {
      if (!li.dataset.searchFolded) li.dataset.searchFolded = fold(li.dataset.search);
      var show = (!q || li.dataset.searchFolded.indexOf(q) !== -1)
        && (!only || li.dataset.hasStock !== '0');
      li.hidden = !show;
      if (show) visible += 1;
    });
    var empty = modal.querySelector('[data-nb-empty]');
    if (empty) empty.hidden = visible !== 0;
  }

  function bindTools(modal) {
    if (modal.dataset.nbBound === '1') return;
    modal.dataset.nbBound = '1';
    modal.querySelector('[data-nb-search]').addEventListener('input', function () {
      applyFilters(modal);
    });
    modal.querySelector('[data-nb-only-stock]').addEventListener('change', function () {
      applyFilters(modal);
    });
  }

  function applyAvailability(modal, payload) {
    var av = payload.availability || {};
    modal.querySelectorAll('.nb-store').forEach(function (li) {
      var branch = li.dataset.branch;
      var any = false;
      li.querySelectorAll('.nb-chip').forEach(function (chip) {
        var rec = av[chip.dataset.ean];
        var state = rec && rec[branch] ? rec[branch] : 0;
        chip.classList.remove('nb-chip--loading', 'nb-chip--ok', 'nb-chip--last', 'nb-chip--none');
        chip.classList.add(state === 2 ? 'nb-chip--ok' : state === 1 ? 'nb-chip--last' : 'nb-chip--none');
        if (state > 0) any = true;
      });
      li.dataset.hasStock = any ? '1' : '0';
    });
    if (payload.updatedAt) {
      var wrap = modal.querySelector('[data-nb-updated]');
      var time = modal.querySelector('[data-nb-updated-time]');
      if (wrap && time) {
        try {
          time.textContent = new Date(payload.updatedAt).toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
          });
          wrap.hidden = false;
        } catch (e) {
          /* formát času je jen kosmetika */
        }
      }
    }
  }

  function load(modal) {
    bindTools(modal);
    highlightCurrent(modal);
    if (modal.dataset.nbLoaded === '1' || modal.dataset.nbLoading === '1') return;
    var dataEl = modal.querySelector('[data-nb-branch-data]');
    if (!dataEl) return;
    var conf;
    try {
      conf = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!conf.eans || !conf.eans.length) return;
    modal.dataset.nbLoading = '1';
    var errorEl = modal.querySelector('[data-nb-error]');
    if (errorEl) errorEl.hidden = true;
    fetch(conf.endpoint + '?eans=' + conf.eans.join(','))
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (payload) {
        applyAvailability(modal, payload);
        modal.dataset.nbLoaded = '1';
        applyFilters(modal);
      })
      .catch(function () {
        if (errorEl) errorEl.hidden = false;
        modal.querySelectorAll('.nb-chip').forEach(function (chip) {
          chip.classList.remove('nb-chip--loading');
        });
      })
      .finally(function () {
        modal.dataset.nbLoading = '0';
      });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-nb-branch-opener]');
    if (!opener) return;
    var modal = document.getElementById(opener.getAttribute('data-nb-branch-opener'));
    if (modal) load(modal);
  });
})();
